import { intervalToDuration, parseISO } from "date-fns";
import type { IntlShape } from "react-intl";

export function getAge(
  record: { dateOfBirth?: string | null | Date; date: string | Date },
  formatMessage: IntlShape["formatMessage"],
) {
  let start = new Date(0);
  if (record.dateOfBirth instanceof Date) {
    start = record.dateOfBirth;
  } else if (typeof record.dateOfBirth === "string") {
    start = parseISO(record.dateOfBirth);
  }
  const end = new Date(record.date);

  const age = intervalToDuration({
    start,
    end,
  });

  if ((age.years ?? 0) < 3) {
    return formatMessage(
      { id: "register.age.under3", defaultMessage: "{months}m" },
      { months: (age?.years ?? 0) * 12 + (age?.months ?? 0) },
    );
  }

  return age.years;
}
